// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles for DeviceList component
 */

.device-list {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.device-list__header {
  padding: 20px;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.device-list__header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.device-list__items {
  max-height: 400px;
  overflow-y: auto;
}

/* Device list item */
.device-list-item {
  padding: 15px 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.2s;
}

.device-list-item:last-child {
  border-bottom: none;
}

.device-list-item:hover {
  background-color: #f8f9fa;
}

.device-list-item--current {
  background-color: #f0f8ff;
}

.device-list-item--current:hover {
  background-color: #e6f4ff;
}

.device-list-item__info {
  flex: 1;
}

.device-list-item__header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}

.device-list-item__name {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.device-list-item__current-badge {
  font-size: 12px;
  color: #007bff;
  font-weight: normal;
  margin-left: 5px;
}

.device-list-item__details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.device-list-item__id,
.device-list-item__last-seen {
  font-size: 12px;
  color: #666;
}

.device-list-item__actions {
  margin-left: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Device logout button */
.device-logout-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s, color 0.2s;
  color: #666;
}

.device-logout-button:hover {
  background-color: #fee;
  color: #dc3545;
}

.device-logout-button ion-icon {
  font-size: 20px;
  pointer-events: none;
}

.device-logout-button:active {
  background-color: #fdd;
}

/* Loading state */
.device-list--loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.device-list--loading .spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f0f0f0;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Error state */
.device-list--error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.device-list--error .error-message {
  color: #dc3545;
  margin-bottom: 20px;
}

/* Empty state */
.device-list--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: #666;
}

/* Button variations */
.btn-sm {
  padding: 6px 12px;
  font-size: 12px;
}

/* Dark theme */
@media (prefers-color-scheme: dark) {
  .device-list {
    background: #1e1e1e;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }

  .device-list__header {
    border-bottom-color: #333;
  }

  .device-list__header h3 {
    color: #e0e0e0;
  }

  .device-list-item {
    border-bottom-color: #2a2a2a;
  }

  .device-list-item:hover {
    background-color: #2a2a2a;
  }

  .device-list-item--current {
    background-color: #1a2a3a;
  }

  .device-list-item--current:hover {
    background-color: #1e3148;
  }

  .device-list-item__name {
    color: #e0e0e0;
  }

  .device-list-item__current-badge {
    color: #60a5fa;
  }

  .device-list-item__id,
  .device-list-item__last-seen {
    color: #999;
  }

  .device-list--empty {
    color: #999;
  }

  .device-logout-button {
    color: #999;
  }

  .device-logout-button:hover {
    background-color: #3a1a1a;
    color: #ff6b6b;
  }

  .device-logout-button:active {
    background-color: #4a2020;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/devices/DeviceList.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/**\n * Styles for DeviceList component\n */\n\n.device-list {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.device-list__header {\n  padding: 20px;\n  border-bottom: 1px solid #e5e5e5;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.device-list__header h3 {\n  margin: 0;\n  font-size: 18px;\n  color: #333;\n}\n\n.device-list__items {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n/* Device list item */\n.device-list-item {\n  padding: 15px 20px;\n  border-bottom: 1px solid #f0f0f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: background-color 0.2s;\n}\n\n.device-list-item:last-child {\n  border-bottom: none;\n}\n\n.device-list-item:hover {\n  background-color: #f8f9fa;\n}\n\n.device-list-item--current {\n  background-color: #f0f8ff;\n}\n\n.device-list-item--current:hover {\n  background-color: #e6f4ff;\n}\n\n.device-list-item__info {\n  flex: 1;\n}\n\n.device-list-item__header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 5px;\n}\n\n.device-list-item__name {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n\n.device-list-item__current-badge {\n  font-size: 12px;\n  color: #007bff;\n  font-weight: normal;\n  margin-left: 5px;\n}\n\n.device-list-item__details {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.device-list-item__id,\n.device-list-item__last-seen {\n  font-size: 12px;\n  color: #666;\n}\n\n.device-list-item__actions {\n  margin-left: 20px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* Device logout button */\n.device-logout-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background-color 0.2s, color 0.2s;\n  color: #666;\n}\n\n.device-logout-button:hover {\n  background-color: #fee;\n  color: #dc3545;\n}\n\n.device-logout-button ion-icon {\n  font-size: 20px;\n  pointer-events: none;\n}\n\n.device-logout-button:active {\n  background-color: #fdd;\n}\n\n/* Loading state */\n.device-list--loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.device-list--loading .spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #f0f0f0;\n  border-top: 3px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Error state */\n.device-list--error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.device-list--error .error-message {\n  color: #dc3545;\n  margin-bottom: 20px;\n}\n\n/* Empty state */\n.device-list--empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n  color: #666;\n}\n\n/* Button variations */\n.btn-sm {\n  padding: 6px 12px;\n  font-size: 12px;\n}\n\n/* Dark theme */\n@media (prefers-color-scheme: dark) {\n  .device-list {\n    background: #1e1e1e;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  }\n\n  .device-list__header {\n    border-bottom-color: #333;\n  }\n\n  .device-list__header h3 {\n    color: #e0e0e0;\n  }\n\n  .device-list-item {\n    border-bottom-color: #2a2a2a;\n  }\n\n  .device-list-item:hover {\n    background-color: #2a2a2a;\n  }\n\n  .device-list-item--current {\n    background-color: #1a2a3a;\n  }\n\n  .device-list-item--current:hover {\n    background-color: #1e3148;\n  }\n\n  .device-list-item__name {\n    color: #e0e0e0;\n  }\n\n  .device-list-item__current-badge {\n    color: #60a5fa;\n  }\n\n  .device-list-item__id,\n  .device-list-item__last-seen {\n    color: #999;\n  }\n\n  .device-list--empty {\n    color: #999;\n  }\n\n  .device-logout-button {\n    color: #999;\n  }\n\n  .device-logout-button:hover {\n    background-color: #3a1a1a;\n    color: #ff6b6b;\n  }\n\n  .device-logout-button:active {\n    background-color: #4a2020;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
